import Add from '@assets/icons/add.svg'
import { Icon } from './Icon'

export const AddIcon = Icon(Add)
